<template>
<div class="form">
  <v-card style="margin-top: 250px">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <h1 align="center" style="text-decoration: underline overline;">JRC - Pindahan Semasa Dibayar</h1>
      <!-- <h2 align="center" style="text-decoration:">Pindahan Semasa Dibayar</h2> -->
        <v-text-field
          outlined 
          dense
          rounded
          v-model="HID"
          label="HID"
          width="20px"
          disabled
        ></v-text-field>

      <!-- DATATABLE  -->
      <v-card color="rgba(217, 217, 217, 0.5)" class="mb-5">
            <v-card-title>
                Senarai
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="dataJRCPSD"
              :search="search"
              class="ml-3 mr-3"
              @click:row="handleClick"
            ><template v-slot:item.TP61_a= "{ item }">
            {{ formatNumber(item.TP61_a) }}
          </template>
          <template v-slot:item.TP61_b= "{ item }">
            {{ formatNumber(item.TP61_b) }}
          </template>
          <template v-slot:item.TP61_c= "{ item }">
            {{ formatNumber(item.TP61_c) }}
          </template>
          <template v-slot:item.TP61= "{ item }">
            {{ formatNumber(item.TP61) }}
          </template>
          <template v-slot:item.TP62= "{ item }">
            {{ formatNumber(item.TP62) }}
          </template>
          <template v-slot:item.TP63= "{ item }">
            {{ formatNumber(item.TP63) }}
          </template>
          <template v-slot:item.TP64_a= "{ item }">
            {{ formatNumber(item.TP64_a) }}
          </template>
          <template v-slot:item.TP64_b= "{ item }">
            {{ formatNumber(item.TP64_b) }}
          </template>
          <template v-slot:item.TP64_c= "{ item }">
            {{ formatNumber(item.TP64_c) }}
          </template>
          <template v-slot:item.TP64= "{ item }">
            {{ formatNumber(item.TP64) }}
          </template>
          <template v-slot:item.TP65= "{ item }">
            {{ formatNumber(item.TP65) }}
          </template>
          <template v-slot:item.TP66= "{ item }">
            {{ formatNumber(item.TP66) }}
          </template>
          <template v-slot:item.TP67= "{ item }">
            {{ formatNumber(item.TP67) }}
          </template>
          <template v-slot:item.TP73A= "{ item }">
            {{ formatNumber(item.TP73A) }}
          </template>
          <template v-slot:item.TP68= "{ item }">
            {{ formatNumber(item.TP68) }}
          </template>
          <template v-slot:item.TP69= "{ item }">
            {{ formatNumber(item.TP69) }}
          </template>
          <template v-slot:item.TP70= "{ item }">
            {{ formatNumber(item.TP70) }}
          </template>
          <template v-slot:item.TP71= "{ item }">
            {{ formatNumber(item.TP71) }}
          </template>
          <template v-slot:item.TP72_a= "{ item }">
            {{ formatNumber(item.TP72_a) }}
          </template>
          <template v-slot:item.TP72_b= "{ item }">
            {{ formatNumber(item.TP72_b) }}
          </template>
          <template v-slot:item.TP72_c= "{ item }">
            {{ formatNumber(item.TP72_c) }}
          </template>
          <template v-slot:item.TP73B= "{ item }">
            {{ formatNumber(item.TP73B) }}
          </template>
          <template v-slot:item.TP73= "{ item }">
            {{ formatNumber(item.TP73) }}
          </template>
          <template v-slot:item.TP74= "{ item }">
            {{ formatNumber(item.TP74) }}
          </template>
        
        </v-data-table>
      </v-card>    
    </v-card>


<!-- ISI BORANG -->
<v-card>
<v-card-title>
Bayaran Wajib/Denda
</v-card-title>
<v-card-text>
  <v-form ref="form" v-model="valid" lazy-validation>


<v-row>
 <v-col class="black--text"> 
        S127 :  Bayaran wajib
</v-col>                  
</v-row>

<v-row>
   <v-col class="black--text">  
         i) Cukai pendapatan <strong>[TP61a]</strong>
        <v-text-field
          v-model="TP61_a"
          label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
         >
      </v-text-field>
  </v-col>  


   

    <v-col class="black--text">      
         ii) Zakat pendapatan <strong>[TP61b]</strong>
        <v-text-field
          v-model="TP61_b"
         label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
         >
      </v-text-field>
  </v-col>  

   <v-col class="black--text">      
          [iii] Lain-lain zakat
          (cth.: harta, perniagaan, dll. kecuali zakat fitrah) <strong>[TP61c]</strong>
        <v-text-field
          v-model="TP61_c"
         label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
         >
      </v-text-field>
</v-col>  
</v-row>

<v-row>
   <v-col cols ="4" class="black--text">    
       Jumlah Bayaran Wajib <strong>[TP61]</strong>
         <v-text-field
          v-model="TP61"
           type="number"
          label="RM"
          outlined 
          dense
          persistent-hint
          hint="Setahun"
          disabled>
          </v-text-field> 
</v-col>
        
</v-row>

<v-row>
 
<v-col cols ="4" class="black--text">
<br>
         S128 : Cukai lain
         (cth.: cukai jalan, cukai lapangan terbang, dll.) <strong>[TP62]</strong>

 <v-text-field
          v-model="TP62"
          type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
          >
        </v-text-field>              
</v-col>

<v-col cols ="4" class="black--text">
         S129 : Bayaran wajib dan denda
         (cth.: bayaran pasport, ujian memandu, pendaftaran kereta motor, lesen memandu, dll.) <strong>[TP63]</strong>
 <v-text-field
          v-model="TP63"
          type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
          >
        </v-text-field>              
</v-col>
</v-row>

<v-row>
 <v-col class="black--text"> 
        S130 : Caruman kepada KWSP/ Skim Keselamatan Sosial (caruman majikan dan pekerja) 
</v-col>                  
</v-row>
<v-row>  
        <v-col class="black--text">   
         i) KWSP <strong>[TP64a]</strong>
        <v-text-field
        v-model="TP64_a"
          type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
          >
        </v-text-field>
  </v-col>  

        <v-col class="black--text">   
         ii) PERKESO <strong>[TP64b]</strong>
        <v-text-field
        v-model="TP64_b"
          type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
          >
        </v-text-field>
  </v-col>  

        <v-col class="black--text">   
         iii) Lain-lain <strong>[TP64c]</strong>
        <v-text-field
        v-model="TP64_c"
          type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
          >
        </v-text-field>
  </v-col>  

  <v-col class="black--text">   
      Jumlah caruman majikan dan pekerja <strong>[TP64]</strong>
      <v-text-field
       v-model="TP64"
         type="number"
          label="RM"
          outlined 
          dense
          persistent-hint
          hint="Setahun"
          disabled
          >
        </v-text-field>

 </v-col> 

</v-row>


<v-row>

  <v-col class="black--text">   
      S131 : Bayaran pampasan kerana kecederaan, ganti rugi berdasarkan undang-undang, dll. <strong>[TP65]</strong>
      <v-text-field
       v-model="TP65"
        type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
          >
        </v-text-field>
 </v-col> 

 <v-col class="black--text">   
   <br>
      S132: Bayaran nafkah atau harta warisan <strong>[TP66]</strong>
      <v-text-field
       v-model="TP66"
        type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
          >
        </v-text-field>
</v-col>
      <v-col class="black--text">   
        <br>
      S133: Bayaran pinjaman pelajaran <strong>[TP67]</strong>
      <v-text-field
       v-model="TP67"
         type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
          >
        </v-text-field>
      </v-col>

    <v-col class="black--text"> 
    <br>
     S134 : Jumlah Bayaran Wajib dan Denda <strong>[TP73A]</strong>
        <v-text-field
          v-model="TP73A"
          type="number"
          label="RM"
          outlined 
          dense
          persistent-hint
          hint="Setahun"
          disabled
          >
        </v-text-field>
    </v-col>     
</v-row>
</v-form>
</v-card-text>
</v-card>

<v-card>
<v-card-title>
Bayaran Sukarela
</v-card-title>
<v-card-text>
  <v-form ref="form" v-model="valid" lazy-validation>

<v-row>
   <v-col cols ="4" class="black--text">
    <br>
       S135 : Pemberian kepada badan agama atau derma amal <strong>[TP68]</strong>
       <v-text-field
          v-model="TP68"
          type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
          >
        </v-text-field>              
 </v-col>

 <v-col cols ="4" class="black--text">
       S136 : Yuran keahlian kepada kesatuan sekerja, parti politik, kelab sosial, dll <strong>[TP69]</strong>
       <v-text-field
          v-model="TP69"
          type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
          >
        </v-text-field>              
 </v-col>
      
</v-row>


<v-row>

  <v-col cols ="4" class="black--text">
       S137 : Hadiah berupa wang tunai atau mata benda <strong>[TP70]</strong>
       <v-text-field
          v-model="TP70"
          type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
          >
        </v-text-field>              
 </v-col>
  
  <v-col cols ="4" class="black--text">
       S138 : Pindahan lain (contoh : Zakat Fitrah) <strong>[TP71]</strong>
       <v-text-field
          v-model="TP71"
          type="number"
          label="RM"
          outlined 
          dense
          required
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
          >
        </v-text-field>              
 </v-col>
      
</v-row>



<v-row>
   <v-col cols ="4" class="black--text">
        S139 : Pemberian kepada isi rumah lain
    </v-col>                  
</v-row>

<v-row>

  <v-col class="black--text">  
         i) Malaysia <strong>[TP72a]</strong>
        <v-text-field
          v-model="TP72_a"
          label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
         >
      </v-text-field>
  </v-col>  
   
     <v-col class="black--text">  
         ii) Negara Lain <strong>[TP72b]</strong>
        <v-text-field
          v-model="TP72_b"
          label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
         >
      </v-text-field>
  </v-col>  
   
     <v-col class="black--text" v-show="showTP72c">  
         iii) Nyatakan negara di (ii) <strong>[TP72c]</strong>
        <v-text-field
          v-model="TP72_c"
          outlined 
          dense
          persistent-hint
         >
      </v-text-field>
  </v-col>  
</v-row>

<v-row>
   <v-col cols ="4" class="black--text">    
       S140 : Jumlah bayaran sukarela <strong>[TP73B]</strong>
         <v-text-field
          v-model="TP73B"
           type="number"
          label="RM"
          outlined 
          dense
          persistent-hint
          hint="Setahun"
          disabled>
          </v-text-field> 
</v-col>
  <v-col cols ="4" class="black--text">   
     S141 : Jumlah bayaran pindahan semasa <strong>[TP73]</strong>
         <v-text-field
          v-model="TP73"
           type="number"
          label="RM"
          outlined 
          dense
          persistent-hint
          hint="Setahun"
          disabled>
          </v-text-field> 
</v-col>

<v-col cols ="4" class="black--text">   
     S142 : Jumlah simpanan tunai dalam 12 bulan yang lalu <strong>[TP74]</strong>
         <v-text-field
          v-model="TP74"
           label="RM"
          outlined 
          type="number"
          dense
          persistent-hint
          hint="Setahun"
          @keypress="limitDigits"
          :rules="schemeRule.no8digit"
         >
      </v-text-field>
</v-col>


</v-row>

</v-form>
</v-card-text>

<v-card-actions>
 <v-spacer></v-spacer>
    <v-btn
        text
        color="primary"
        @click='simpan()'
        v-show="butangSimpan"
    >
      Simpan/Kemaskini
    </v-btn>

    <!-- <v-btn
        text
        color="primary"
        v-show="butangKemaskini"
      @click="updateJRCPSD()"
    >
      Kemaskini
    </v-btn> -->
    
    <!--<v-btn
      text
      color="primary"
      @click="goTo()"
    >
      Seterusnya
    </v-btn> -->
</v-card-actions>
</v-card>

<!-- <v-alert
  prominent
  type="error"
  :value="popUpALert"
 >
  <v-row align="center" class="mb-2">
    <v-col class="grow">
      Adakah anda pasti untuk padam?
    </v-col>
    <v-col class="shrink">
      <v-btn @click="padam('1')" class="mb-3">Confirm</v-btn>
      <v-btn @click="padam('2')">Cancel</v-btn>
    </v-col>
  </v-row>
</v-alert> -->

<!-- Error Dialog -->
<v-dialog
      v-model="errorDialog"
      width="500"
      height="200"
    >
    <v-card>
      <v-alert
        dense
        outlined
        color="#C51162"
        type="error"
      >
      <strong>{{errMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

<!-- Success Dialog -->
<v-dialog
      v-model="successDialog"
      width="500"
      height="200"
    >
    <v-card
    color="success"
    >
      <v-alert
        dense
        outlined
        color="#C51162"
        type="success"
      >
      <strong>{{successMessage}}</strong>
      </v-alert>
    </v-card>
</v-dialog>

</div>
</template>
<script>
import axios from '../../plugins/axios'
import schemeRule from '../../utils/scheme'

/////////////////////////////////////////////////////////
import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();

import lookupField from '@/services/lookupField'
const lookupFieldServices = new lookupField();
/////////////////////////////////////////////////////////
export default {

    beforeMount(){
        var dataHID = localStorageData.getHIDdata()

        this.HID = dataHID.HID;
        this.BNO = dataHID.BNO;
        this.Ps = dataHID.P;
        this.S = dataHID.S;
        this.NG = dataHID.NG;
        this.DP = dataHID.DP;
        this.DB =  dataHID.DB;
        this.BP = dataHID.BP;
        this.ST = dataHID.ST;
        this.NOTK = dataHID.NOTK;
        this.NOIR = dataHID.NOIR;
        this.Bulan = dataHID.BULAN;

        this.currNOAIRData = localStorageData.getCurrentNOAIRData();//dapatkan NOAIR yang di click dari page depan
        this.NOAIR = this.currNOAIRData.NOAIR;

        this.getData();//dapatkan data based on HID

///////////////////////////////lookup table yang diperlukan//////////////////

        // this.yaTidak = lookupFieldServices.getYaTidak();


    },
    data: () => ({
        valid: true,
        updateButton: true,
        saveButton: false,
        dialog: false,
        successDialog: false,
        errorDialog: false,
        successMessage:'',
        errMessage:'',
        message: "Saving Data",
        popUpALert:false,
        search: '',
        butangSimpan: true,
        butangKemaskini: false,
        dataJRCPSD: [],
        showTP72c: false,
/////////////////////data declaration//////////////////////////
        HID: '',
        KAW: '',
        Bulan:'',
        Tahun:'',
        BNO:'',
        Ps:'',
        S:'',
        NG: '',
        DP:'',
        DB:'',
        BP:'',
        ST:'',
        NOTK:'',
        NOIR:'',
        R:'',
      
        TP61_a:0,
        TP61_b:0,
        TP61_c:0,
        TP62:0,
        TP63:0,
        TP64_a:0,
        TP64_b:0,
        TP64_c:0,
        TP65:0,
        TP66:0,
        TP67:0,
        TP68:0,
        TP69:0,
        TP70:0,
        TP71:0,
        TP72_a:0,
        TP72_b:0,
        TP72_c: 0,
        TP74:0,
        rules: [
        value => !!value || 'Required.',
      ],

        headers: [
          {
            text: 'NOAIR',
            align: 'start',
            sortable: false,
            value: 'NOAIR',
          },
          { text: 'TP61a', value: 'TP61_a' },
          { text: 'TP61b', value: 'TP61_b' },
          { text: 'TP61c', value: 'TP61_c' },
          { text: 'TP61', value: 'TP61' },
          { text: 'TP62', value: 'TP62' },
          { text: 'TP63', value: 'TP63' },
          { text: 'TP64a', value: 'TP64_a' },
          { text: 'TP64b', value: 'TP64_b' },
          { text: 'TP64c', value: 'TP64_c' },
          { text: 'TP64', value: 'TP64' },
          { text: 'TP65', value: 'TP65' },
          { text: 'TP66', value: 'TP66' },
          { text: 'TP67', value: 'TP67' },
          { text: 'TP73A', value: 'TP73A' },
          { text: 'TP68', value: 'TP68' },
          { text: 'TP69', value: 'TP69' },
          { text: 'TP70', value: 'TP70' },
          { text: 'TP71', value: 'TP71' },
          { text: 'TP72a', value: 'TP72_a' },
          { text: 'TP72b', value: 'TP72_b' },
          { text: 'TP72c', value: 'TP72_c' },
          { text: 'TP73B', value: 'TP73B' },
          { text: 'TP73', value: 'TP73' },
          { text: 'TP74', value: 'TP74' },
        ],
       
      breadcrumbs: [
        {
           text: 'Status Pengisian',
          disabled: false,
          href: 'ringkasanMaklumatIR',
        },
         {
          text: 'JRC Pindahan Semasa Dibayar',
          disabled: true,
          href: 'JRCPSD',
        },
      ],
     
    }),

    methods: {
      formatNumber(value) {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
      stripCommas(value) {
        return value.replace(/,/g, '');
      },
      getUnits: function(a) {
            alert(`${a}`)
      },
      limitDigits(event) {
        const value = event.target.value;
        if (value.length >= 8 ) {
            event.preventDefault();
        }
      },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      goTo(){
          this.$router.push({name: "JRD"});
      },
      async simpan (){
                console.log(this.TP72_b)
                console.log(this.TP72_c)

                if (this.$refs.form.validate()){
                  this.dialog =  true;
                  setTimeout(() => (this.dialog = false), 2000)

                try {

                  const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/JRCPSD`, {
                
                  TP61_a: this.TP61_a, 
                  TP61_b: this.TP61_b,
                  TP61_c: this.TP61_c,
                  TP61: this.TP61,
                  TP62: this.TP62,
                  TP63: this.TP63,
                  TP64_a: this.TP64_a,
                  TP64_b: this.TP64_b,
                  TP64_c: this.TP64_c,
                  TP64: this.TP64,
                  TP65: this.TP65,
                  TP66: this.TP66,
                  TP67: this.TP67,
                  TP73A: this.TP73A,
                  TP68: this.TP68,
                  TP69: this.TP69, 
                  TP70: this.TP70,
                  TP71: this.TP71,
                  TP72_a: this.TP72_a,
                  TP72_b: this.TP72_b,
                  TP72_c: this.TP72_c,
                  TP73B: this.TP73B,
                  TP73: this.TP73,
                  TP74: this.TP74,
                  HID:  this.HID,
                  NOAIR:  this.NOAIR,
                  
                })
                      this.res = res.data;
                      this.reset();
                      this.getData();
                      this.successDialog = true;
                      setTimeout(() => (this.successDialog = false), 2000);
                      this.successMessage = 'Data Disimpan!';
                      //this.getData();
                      //setTimeout(() => (this.goTo()), 2000);
                      
                      
                  } catch (error) {
                    //console.log(error)
                    this.errorDialog = true;
                    setTimeout(() => (this.errorDialog = false), 2000);
                    this.errMessage = 'Simpan : '+error;

              }
                
            }
      },
      async updateJRCPSD(){
          console.log(this.TP72_b)
          try {

            const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/updateJRCPSD`, {
          
            TP61_a: this.TP61_a, 
            TP61_b: this.TP61_b,
            TP61_c: this.TP61_c,
            TP61: this.TP61,
            TP62: this.TP62,
            TP63: this.TP63,
            TP64_a: this.TP64_a,
            TP64_b: this.TP64_b,
            TP64_c: this.TP64_c,
            TP64: this.TP64,
            TP65: this.TP65,
            TP66: this.TP66,
            TP67: this.TP67,
            TP73A: this.TP73A,
            TP68: this.TP68,
            TP69: this.TP69, 
            TP70: this.TP70,
            TP71: this.TP71,
            TP72_a: this.TP72_a,
            TP72_b: this.TP72_b,
            TP72_c: this.TP72_c,
            TP73B: this.TP73B,
            TP73: this.TP73,
            TP74: this.TP74,
            HID:  this.HID,
            NOAIR:  this.NOAIR,
          })
                this.res = res.data
                this.butangKemaskini = false;
                this.successDialog = true;
                this.reset();
                this.getData();
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Berjaya Dikemaskini!';
                //this.getData();
                 setTimeout(() => (this.goTo()), 2000);
                
                
          } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Simpan : '+error;
          }
          
      },
      async padam(val){
        if(val == 0){
          this.popUpALert = true; 
        }
        else if(val == 1){
          
          try {
              ///////////tunjukkan alert padam////////////
              this.popUpALert = false;
                ////send delete to API///////
              if (this.$refs.form.validate()){
                const res = await axios.post(`${process.env.VUE_APP_API_URL}/JR5/JRCPSD/delete`, {
                HID:  this.HID,
                NOAIR: this.NOAIR,
              })
                this.res = res.data
                this.successDialog = true;
                setTimeout(() => (this.successDialog = false), 2000);
                this.successMessage = 'Data Deleted!'
                this.saveButton = false;
                this.updateButton = true;
                this.reset();
                this.getData(); 
              }else{
                this.errorDialog = true;
                setTimeout(() => (this.errorDialog = false), 2000);
                this.errMessage = "Please Fill In the field"
              }
              
            } catch (error) {
              //console.log(error)
              this.errorDialog = true;
              setTimeout(() => (this.errorDialog = false), 2000);
              this.errMessage = 'Padam : '+error;
            }
        }
        else if(val == 2){
          this.popUpALert = false;
        }
          
      },
      async getData(){

        //dapatkan data dari table HK1 based on HID

        try {
            const res = await axios.get(`${process.env.VUE_APP_API_URL}/JR5/getJRCPSD?HID=`+this.HID+`&NOAIR=`+this.NOAIR, {
            })
            var dataz = res.data.data;
            this.dataJRCPSD = dataz;
          } catch (error) {
            //console.log(error)
            this.errorDialog = true;
            setTimeout(() => (this.errorDialog = false), 2000);
            this.errMessage = 'getData : '+ error;
          }

      },
      handleClick(row) {
        console.log('Row clicked:', row);

        this.successDialog = true;
        this.successMessage = "Sila mulakan pengemaskinian!";
        this.butangKemaskini = true;

        // this.HID = row.HID;
        // this.NOAIR = row.NOAIR,
        this.TP61_a = this.stripCommas(row.TP61_a);
        this.TP61_b = this.stripCommas(row.TP61_b);
        this.TP61_c = this.stripCommas(row.TP61_c);
        this.TP61 = this.stripCommas(row.TP61);
        this.TP62 = this.stripCommas(row.TP62);
        this.TP63 = this.stripCommas(row.TP63);
        this.TP64_a = this.stripCommas(row.TP64_a);
        this.TP64_b = this.stripCommas(row.TP64_b);
        this.TP64_c = this.stripCommas(row.TP64_c);
        this.TP64 = this.stripCommas(row.TP64);
        this.TP65 = this.stripCommas(row.TP65);
        this.TP66 = this.stripCommas(row.TP66);
        this.TP67 = this.stripCommas(row.TP67);
        this.TP73A = this.stripCommas(row.TP73A);
        this.TP68 = this.stripCommas(row.TP68);
        this.TP69 = this.stripCommas(row.TP69);
        this.TP70 = this.stripCommas(row.TP70);
        this.TP71 = this.stripCommas(row.TP71);
        this.TP72_a = this.stripCommas(row.TP72_a);
        this.TP72_b = this.stripCommas(row.TP72_b);
        this.TP72_c = this.stripCommas(row.TP72_c);
        this.TP73B = this.stripCommas(row.TP73B);
        this.TP73 = this.stripCommas(row.TP73);
        this.TP74 = this.stripCommas(row.TP74);

      },
    },  
//COMPUTED

    //calculation lain letak bawah ni
 computed:{
      TP61:function(){
        var total = 0;
        total = Number(this.TP61_a) + Number(this.TP61_b) + Number(this.TP61_c)
        return total.toFixed(2);
      },
      TP64:function(){
        var total = 0;
        total = Number(this.TP64_a) + Number(this.TP64_b) + Number(this.TP64_c)
        return total.toFixed(2);
      },

      TP73A:function(){
        var total = 0;
        total = Number(this.TP61) + Number(this.TP62) 
        + Number(this.TP63) + Number(this.TP64)
         + Number(this.TP65) + Number(this.TP66)
         + Number(this.TP67)
          
        return total.toFixed(2);
      },
      TP73B:function(){
        var total = 0;
        total = Number(this.TP68) + Number(this.TP69) 
        + Number(this.TP70) + Number(this.TP71)
         + Number(this.TP72_a) + Number(this.TP72_b) 
        return total.toFixed(2);
      },
      TP73:function(){
        var total = 0;
        total = Number(this.TP73A) + Number(this.TP73B)
        return total.toFixed(2);
      },
      // dataJRCPSD() {
      //   return this.dataJRCPSD.map(item => ({
      //     ...item,
      //     TP61_a: this.formatNumber(item.TP61_a),
      //     TP61_b: this.formatNumber(item.TP61_b),
      //     TP61_c: this.formatNumber(item.TP61_c),
      //     TP61: this.formatNumber(item.TP61),
      //     TP62: this.formatNumber(item.TP62),
      //     TP63: this.formatNumber(item.TP63),
      //     TP64_a: this.formatNumber(item.TP64_a),
      //     TP64_b: this.formatNumber(item.TP64_b),
      //     TP64_c: this.formatNumber(item.TP64_c),
      //     TP64: this.formatNumber(item.TP64),
      //     TP65: this.formatNumber(item.TP65),
      //     TP66: this.formatNumber(item.TP66),
      //     TP67: this.formatNumber(item.TP67),
      //     TP73A: this.formatNumber(item.TP73A),
      //     TP68: this.formatNumber(item.TP68),
      //     TP69: this.formatNumber(item.TP69),
      //     TP70: this.formatNumber(item.TP70),
      //     TP71: this.formatNumber(item.TP71),
      //     TP72_a: this.formatNumber(item.TP72_a),
      //     TP72_b: this.formatNumber(item.TP72_b),
      //     TP72_c: this.formatNumber(item.TP72_c),
      //     TP73B: this.formatNumber(item.TP73B),
      //     TP73: this.formatNumber(item.TP73),
      //     TP74: this.formatNumber(item.TP74),
      //   }));
      // },
      schemeRule() {
      return schemeRule;
    },

 },

 watch: {
    TP72_b(val) {
      if (this.TP72_b >= 1) {
        this.showTP72c = true;
      } else {
        this.showTP72c = false;
        this.TP72_c = 0;
      }
    },
  },
  
    } 
</script>

<style>
#app {
  background: url('~@/assets/HIES.jpg')
  no-repeat center center fixed !important;
  background-size: cover;
}

</style>